<script>
  import { Button, ButtonGroup, Input } from "agnostic-svelte"
  import { Link, navigate } from "svelte-routing"
	import {store} from './store'
	
	let userd = store.userd;
	
</script>

<h1>Find your most affordable health plan</h1>
<div class="flex flex-column items-center container">
  <Input bind:value={userd.zip} placeholder="Zip code" />
	<ButtonGroup>
		<Button isGrouped  on:click={() => window.location.href="https://staging.dls-innovation.com/portal/#/"}>Portal</Button>
		<Button isGrouped mode="primary" on:click={() => navigate("/quote")}>See Plans</Button>
	</ButtonGroup>
  
</div>
